import Vue from 'vue';
import Vuex from 'vuex';
import users from '@/store/modules/users';
import notification from '@/store/modules/notification';
import requests from '@/store/modules/requests';
import status from '@/store/modules/status';
import comments from '@/store/modules/comments';
import audit from '@/store/modules/audit';
import paymentDocument from '@/store/modules/paymentDocument';
import tasks from '@/store/modules/tasks';
import valStore from '@/store/modules/valStore';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        users,
        notification,
        requests,
        audit,
        paymentDocument,
        tasks,
        status: {
            ...status,
            namespaced: true,
        },
        comments: {
            ...comments,
            namespaced: true,
        },
        valStore: {
            ...valStore,
            namespaced: true,
        },
    },
});
